module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Alien3.cd00f8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Alien3.jpg
// module id = Yv8v
// module chunks = 0